module.exports = __webpack_public_path__ + "static/media/laptop.1bd2c1db.svg";